import {
    BodyLarge,
    BodyRegular,
    Card,
    FlexCol,
    FlexColMd,
    Headline2,
    Headline3,
    HorizontalRule,
} from 'components/Elements';
import { DOCUMENTS_URL } from 'lib/_api-helpers';
import { ImageDocument } from 'models/FileDocument';
import { ContentContainer, Image } from 'pages/learner/activity/components/task/LearnerTaskContent';
import styled from 'styled-components';
import { sizes } from 'theme';
import strings from 'strings/strings.json';

export type Slide = {
    title: string;
    content: string | null;
    image?: ImageDocument;
    order: number;
};

type PresentationSlidesSectionProps = {
    slides: Slide[];
};

export default function PresentationSlidesSection({ slides }: PresentationSlidesSectionProps): JSX.Element {
    return (
        <FlexColMd>
            <FlexCol>
                <Headline2>{strings.presentationSlidesSection.title}</Headline2>
                <BodyRegular>{`${slides.length} ${strings.presentationSlidesSection.slides}`}</BodyRegular>
            </FlexCol>
            <FlexCol>
                {slides
                    .sort((a, b) => a.order - b.order)
                    .map((slide, index) => {
                        return (
                            <FlexCol key={index}>
                                <Card>
                                    <FlexColMd>
                                        <Headline3>{`${index + 1}. ${slide.title}`}</Headline3>
                                        {!!slide.content && <BodyLarge>{slide.content}</BodyLarge>}
                                        {!!slide.image && (
                                            <ContentContainer>
                                                <Image src={`${DOCUMENTS_URL}/${slide.image.s3Filepath}`} alt={''} />
                                            </ContentContainer>
                                        )}
                                    </FlexColMd>
                                </Card>
                                <Divider />
                            </FlexCol>
                        );
                    })}
            </FlexCol>
        </FlexColMd>
    );
}

const Divider = styled(HorizontalRule)`
    margin: ${sizes.spacingLg} 0;
`;
